import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function Header() {
  const { isAuthenticated, role, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className='bg-gray-800 text-white p-4'>
      <div className='container mx-auto flex justify-between items-center'>
        <h1 className='text-lg font-semibold'>
          <Link to='/'>Restaurant Management</Link>
        </h1>
        <nav>
          {isAuthenticated ? (
            <>
              {role === 'owner' && (
                <Link to='/owner-dashboard'>Owner Dashboard</Link>
              )}
              {role === 'customer' && (
                <Link to='/customer-dashboard'>Customer Dashboard</Link>
              )}
              {role === 'admin' && (
                <Link to='/admin-dashboard'>Admin Dashboard</Link>
              )}
              <button onClick={handleLogout} className='ml-4'>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to='/owner-login'>Owner Login</Link>
              <Link to='/customer-login' className='ml-4'>
                Customer Login
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
